import { createInertiaApp } from "@inertiajs/react";
import { resolvePage } from "./pages";
import { createRoot, hydrateRoot } from "react-dom/client";

export const createApp = (options: Record<string, unknown> = {}) => {
  const pageScript = document.querySelector<HTMLScriptElement>(
    'script[data-page="app"]',
  );
  const page = pageScript?.textContent
    ? JSON.parse(pageScript.textContent)
    : undefined;
  const appElement = document.getElementById("app");

  if (!page && !appElement) {
    console.error(
      "Missing root element.\n\n" +
        "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
        'Considr moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.',
    );
    return Promise.resolve();
  }

  return createInertiaApp({
    page,
    resolve: resolvePage,
    setup: ({ el, App, props }) => {
      if (el) {
        if (el.hasChildNodes()) {
          hydrateRoot(el, <App {...props} />);
        } else {
          createRoot(el).render(<App {...props} />);
        }
      } else {
        console.error(
          "Missing root element.\n\n" +
            "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
            'Considr moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.',
        );
      }
    },
    ...options,
  });
};
